import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { getSoftwareCategories } from '../../../-query/api';
import { CategorySearchSchema } from './-zod-schema';
export const Route = createFileRoute('/_staff/software/_layout/library/category/$category/search/')({
  validateSearch: zodValidator(CategorySearchSchema),
  loader: async () => {
    const categories = await getSoftwareCategories();
    return {
      categories
    } as const;
  }
});